export default __webpack_public_path__ + "static/media/part_2.ace3a682.svg";